import * as React from 'react';
import { DropDownDto } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';
import { DropDownRowViewModelImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownviewmodel';
import { ToneOptionDropDownRowCSSStyleImpl } from './toneoptiondropdownrowcss';
import { ToneOptionDropDownRowComponent } from './toneoptiondropdownrowcomponent';

export class ToneOptionDropDownRowViewModelImpl extends DropDownRowViewModelImpl
{   
    getView(t: DropDownDto, position: number): boolean | JSX.Element 
    {
        return <ToneOptionDropDownRowComponent isImageRequired={false} cssStyle={new ToneOptionDropDownRowCSSStyleImpl(this.getContext())} isLastIndex={(position + 1) === this.getListOfDatas().length} onRowSelected={(id) => this.dropdownRowViewModelHandler.onRowSelected(id)} key={position}  context={this.getContext()} dropDownDto={t}  position={position}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneoptions/toneoptiondropdownlistviewmodel.tsx